import { clearEmails } from "../../../store/actions/emailActions";
import { authLogout } from "../../../store/actions/authActions";
import { clearMessage, setMessage } from "../../../store/actions/dialogActions";
import { setNotifications } from "../../../store/actions/notificationActions";
import API from "../../../store/api";

export const sendEmail = (to, bcc, subject, body, attachments, bearerAuth, clearFields) => {
  return async dispatch => {

    dispatch(setMessage({ type: 'LOAD' }))

    let req = API.post(`/api/portal/email`)
      .set('Authorization', `Bearer ${bearerAuth}`)
      .field('data', JSON.stringify({
        to: to,
        bcc: bcc,
        subject: subject,
        html: body,
      }));
      attachments.forEach((file, i) => req.attach('files', file.getRawFile()));
      req.ok(res => res.status === 200 || res.status === 401)
      .then((response) => {
        if (response.status === 200) {
          dispatch(clearMessage)
          //dispatch(getAboutBySite(siteId, bearerAuth))
          dispatch(setNotifications({
            type: 'success',
            message: 'Successfully updated.'
          }))
          clearFields();
        } else if (response.status === 401) {
          dispatch(clearEmails);
          dispatch(authLogout);
        }
      }).catch((error) => {
        let message = 'An error has occurred';
        if (error.message) {
          message = error.message;
        }
        if (error.response && error.response.body) {
          if (error.response.body.messages) {
            message = error.response.body.messages.toString();
          }
        }
        dispatch(setMessage({
          title: 'Send Email Failed',
          message: message,
          type: 'ERR',
        }))
      })
  }
}